import React, {  } from 'react'
import './SchoolLife.css'
import { Header,  } from 'semantic-ui-react'

import { SchoolLifeTab } from './SchoolLifeTab'
import bgImage2 from "../../images/BG2.png";

import BApic1 from "../../images/beyondAcademics/BApic1.png";
import Laboratory from '../../images/schoolLife/Component 3 (1).png'

export const SchoolLife = () => {
  return (
    <div className='mobile' style={{
      backgroundColor: 'rgba(70, 61, 163, 1)'
    }}>
     <div
        className='mobile__top'
        style={{ backgroundImage: `url(${bgImage2})`, backgroundSize: 'cover', background: 'cover' }}
      >
          <img src={BApic1} alt="" className="AcPic" />
         
        <Header as={'h1'} size='huge'>
      School Life
        </Header>
        <img src={Laboratory} alt="" className="icon1" />
        {/* <img src={paperrocket} alt="" className="icon2" /> */}
      </div>
      <div className='mobile__bottom'>
        <SchoolLifeTab/>
      </div>
      
    </div>
  )
}